import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { cva } from 'class-variance-authority';
import cn from '../utils/cn';
import styles from './Avatar.module.css';

const avatar = cva(styles.root, {
  variants: {
    size: { sm: styles.sizeSm, md: styles.sizeMd, xl: styles.sizeXl },
    bordered: { true: styles.bordered },
    clickable: { true: styles.clickable }
  },
  defaultVariants: { size: 'md', bordered: false }
});

const Avatar = React.forwardRef(function Avatar(
  { src, alt = '', size, bordered, to, onError, className, ...rest },
  ref
) {
  const Tag = to ? Link : 'div';
  return (
    <Tag
      ref={ref}
      to={to}
      className={cn(
        avatar({
          size,
          bordered: bordered ? 'true' : undefined,
          clickable: to ? 'true' : undefined
        }),
        className
      )}
      {...rest}>
      <img src={src} alt={alt} onError={onError} className={styles.img} />
    </Tag>
  );
});

Avatar.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'xl']),
  bordered: PropTypes.bool,
  to: PropTypes.string,
  onError: PropTypes.func,
  className: PropTypes.string
};

export default Avatar;
